"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (state = [], action) => {
    if (action.type === 'FETCH_TAGS_SUCCESS') {
        return [...action.tags];
    }
    return state;
};
exports.getTags = (state, keyword) => {
    if (keyword === '') {
        return state;
    }
    return state.filter((val) => {
        return val.toLowerCase().includes(keyword.toLowerCase());
    });
};
